export enum BaseballHitAttribute {
  Single = 1058,
  Double = 1059,
  Triple = 1060,
  BackToBackHit = 857,
}
